/* eslint-disable functional/immutable-data -- imperative DOM manipulation is unavoidable here: this file must work before Angular (or any framework's declarative rendering) has necessarily bootstrapped */

// Eager English source text: no DI, async catalogue loading or ICU compiler in this emergency path.
import english from '../../i18n/catalogues/en.json';

/**
Renders a visible "could not start" state directly into the DOM.

Deliberately framework-free: this runs when the standalone app's runtime
config couldn't be loaded, or `bootstrapApplication` itself rejected —
Angular may never have finished starting, so nothing here can depend on
it. Plain DOM APIs only, and `textContent` (never `innerHTML`) so an
unexpected error message can't be interpreted as markup.
@param host - Element to render the error state into (its existing children are replaced).
@param error - The bootstrap failure to display.
*/
export function renderFatalBootstrapError(host: Readonly<HTMLElement>, error: unknown): void {
  console.error('[Angular Profile MFE] Fatal bootstrap failure.', error);

  host.replaceChildren();

  const container = document.createElement('div');
  container.setAttribute('role', 'alert');
  container.setAttribute('lang', 'en');
  container.style.cssText =
    'display: flex; flex-direction: column; gap: 12px; align-items: flex-start; ' +
    'padding: 24px; font-family: sans-serif; color: #202020;';

  const heading = document.createElement('h1');
  heading.style.cssText = 'margin: 0; font-size: 18px;';
  heading.textContent = english['diagnostics.bootstrap.title'];

  const detail = document.createElement('p');
  detail.style.cssText = 'margin: 0; color: #545454;';
  detail.textContent = describeError(error);

  const reload = document.createElement('button');
  reload.type = 'button';
  reload.textContent = english['diagnostics.reload'];
  reload.addEventListener('click', () => {
    location.reload();
  });

  container.append(heading, detail, reload);
  host.append(container);
}

/**
Describes a thrown value for display.
@param error - The bootstrap failure to describe.
@returns The error's message, or a generic fallback for a non-Error value.
*/
function describeError(error: unknown): string {
  return error instanceof Error ? error.message : english['diagnostics.bootstrap.unknownError'];
}
